$(document).ready(function () {
  $(".popup-with-zoom-anima").magnificPopup({
    type: "inline",

    fixedContentPos: false,
    fixedBgPos: true,

    overflowY: "auto",

    closeBtnInside: true,
    preloader: false,

    midClick: true,
    removalDelay: 300,
    mainClass: "my-mfp-zoom-in",
  });
  $(".ipl_tabs li").click(function () {
    $(".ipl_tabs li").removeClass("active_tab");
    $(".ipl_tabs_content li").removeClass("active_tab");
    $(this).addClass("active_tab");
    var h_active_tab = $(this).data("tab");
    $(".ipl_tabs_content li").each(function () {
      var b_tab = $(this).data("tab");
      if (b_tab == h_active_tab) {
        $(this).addClass("active_tab");
      }
    });
    var sel_tab = $(this).text();
    $(".mobile_ih_title span").text(sel_tab);
  });

  if ($(window).width() < 990) {
    $(".footer-block__details-content").hide();
    $(".footer-block .footer-block__heading").click(function () {
      // $('.footer-block .footer-block__heading').removeClass("open-acc");
      // $(this).toggleClass("open-acc");

      $(this)
        .toggleClass("open-acc")
        .next(".footer-block__details-content")
        .slideToggle()
        .parent()
        .siblings()
        .find(".footer-block__details-content")
        .slideUp()
        .prev()
        .removeClass("open-acc");
    });
  }

  let mybutton = document.querySelector(".sticky-button-wrapper");
  let height = $(".product-section").outerHeight();
  let element = $(".product-section");

  window.onscroll = function () {
    scrollFunction();
  };
  function scrollFunction() {
    if (mybutton) {
      if (
        document.body.scrollTop > height ||
        document.documentElement.scrollTop > height
      ) {
        mybutton.style.cssText = `
        visibility: visible;
        opacity: 1;
      `;
      } else {
        mybutton.style.cssText = `
        visibility: hidden;
        opacity: 0;
      `;
      }
    }
  }
  $("#scrollTop").click(function () {
    $("html, body").animate(
      {
        scrollTop: $(".product__info-container").offset().top,
      },
      500
    );
  });
});

$(document).on("change", ".variant_options input[type='radio']", function () {
  var selectedVariantPrice = parseFloat($(this).data("price")) || 0;
  var moneyFormat = $("body").data("money-format");

  if (!isNaN(selectedVariantPrice)) {
    var dividedPrice = selectedVariantPrice / 4;
    //$(".atc--pricess").html(formatMoney(dividedPrice, moneyFormat));
  }

  // if($('.buy_more-main').length > 0){
  //   setTimeout(function () {
  //     var o_p = $(".buy_more-main .radio input[type=radio]:checked+label .option_price").html();
  //    $(".product__info-container .price").html(o_p);
  //          }, 1100);
  //        }
});

// $(document).on('change', ".variant_options", function(){
//   setTimeout(function () {
// var price = $(".optionPrice").text();
//     $(this ".optionPrice").text(price);
//       }, 1500);
// });

// $(document).on('change', ".variant_options", function(){
//     setTimeout(function () {
//         $(".optionPrice.priceChange").each(function() {
//             var price = $(this).data('price');
//             $(this).text(price);
//         });
//     }, 1500);
// });

// $(document).on('change', ".variant_options", function(){
//     setTimeout(function () {
//         var selectedVariantPrice = $(".price-item--sale.main-price").text();
//         $(".optionPrice.priceChange").each(function() {
//             var basePrice = $(this).data('price');
//             var newPrice = calculateNewPrice(basePrice, selectedVariantPrice);
//             $(this).text(newPrice);
//         });
//     }, 1500);
// });
// function calculateNewPrice(basePrice, selectedVariantPrice) {
//     return basePrice;
// }

// $(document).on('change', ".variant_options", function(){
//     setTimeout(function () {
//         var selectedVariantPrice = $(".price-item--sale.main-price").text();
//         $(".optionPrice.priceChange").each(function() {
//             var basePrice = $(this).data('price');
//             var newPrice = parseFloat(basePrice) + parseFloat(selectedVariantPrice);
//             $(this).text(newPrice.toFixed(2)); // Display the new price with two decimal places
//         });
//     }, 1500);
// });

$(document).on("change", ".variant_options", function () {
  setTimeout(function () {
    var price = $(".price-item--sale.main-price").text();
    $(".atc--price").text(price);    
  }, 1500);
});

if ($(".buy_more-main").length > 0) {
  $(".atc-button").addClass("addToCartMore");
  // $('.add-to-cart').removeClass("add-to-cart");
}
$(document).on("click", ".addToCartMore", function (e) {
  e.preventDefault();
  var productIds = $('input[name="buyMoreOptions"]:checked').data("products");
  var currentProduct = $('input[name="buyMoreOptions"]:checked').data(
    "currentproduct"
  );
  var selectedOptionValue = $(this)
    .closest("form")
    .find('input[name="id"]')
    .val();
  //alert(productIds);
  //alert(selectedOptionValue)
  var products = [];
  products.push({ productId: selectedOptionValue });
  // Split the product IDs by comma
  if (productIds != "") {
    if ($.inArray(",", productIds) !== -1) {
      var productIdArray = productIds.split(",");

      // Create objects with productId property for each ID
      $.each(productIdArray, function (index, productId) {
        productID = parseInt(productId, 10);
        products.push({ productId: productID });
      });
    } else {
      productID = productIds.toString();
      products.push({ productId: productID });
    }
  }
  // Output the resulting array
  console.log(products);
  // Define the products you want to add to the cart

  // Create an array to store the line items
  var lineItems = [];

  // Loop through each product and create line item objects
  $.each(products, function (index, product) {
    var lineItem = {
      id: String(product.productId).replace(/\s+/g, ""), // Remove spaces from product ID
      quantity: 1,
    };

    lineItems.push(lineItem);
  });

  // Send Ajax request to add the line items to the cart

  $.ajax({
    url: "/cart/add.js",
    method: "POST",
    dataType: "json",
    data: {
      items: lineItems,
    },
    success: function (response) {
      // Handle success response
      console.log("Products added to cart successfully");
    },
    error: function (xhr, status, error) {
      // Handle error response
      console.log("Error adding products to cart:", error);
    },
  });
});

// $(".slider-filter").slick({
//   dots:true,
//   slidesToShow: 1,
//   slidesToScroll: 1,
//   arrows: true,
//   centerMode:false,
//   prevArrow: '<button class="slide-arrow prev-arrow"><svg xmlns="http://www.w3.org/2000/svg" width="31" height="30" viewBox="0 0 31 30" fill="none"><path d="M15.1662 29L29.5551 15M29.5551 15L15.1662 1M29.5551 15H0.777344" stroke="#252525" stroke-width="1.3125" stroke-linecap="round" stroke-linejoin="round"/></svg></button>',
//   nextArrow: '<button class="slide-arrow next-arrow"><svg xmlns="http://www.w3.org/2000/svg" width="31" height="30" viewBox="0 0 31 30" fill="none"><path d="M15.1662 29L29.5551 15M29.5551 15L15.1662 1M29.5551 15H0.777344" stroke="#252525" stroke-width="1.3125" stroke-linecap="round" stroke-linejoin="round"/></svg></button>'
// });

//product stat slider - class of the slider has been overwrited from product_stats to product_statss
$(".product_status").slick({
  slidesToShow: 3,
  slidesToScroll: 1,
  arrows: true,
  centerMode: false,
  prevArrow:
    '<button class="slide-arrow prev-arrow"><svg xmlns="http://www.w3.org/2000/svg" width="31" height="30" viewBox="0 0 31 30" fill="none"><path d="M15.1662 29L29.5551 15M29.5551 15L15.1662 1M29.5551 15H0.777344" stroke="#252525" stroke-width="1.3125" stroke-linecap="round" stroke-linejoin="round"/></svg></button>',
  nextArrow:
    '<button class="slide-arrow next-arrow"><svg xmlns="http://www.w3.org/2000/svg" width="31" height="30" viewBox="0 0 31 30" fill="none"><path d="M15.1662 29L29.5551 15M29.5551 15L15.1662 1M29.5551 15H0.777344" stroke="#252525" stroke-width="1.3125" stroke-linecap="round" stroke-linejoin="round"/></svg></button>',
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
        infinite: true,
        dots: false,
      },
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2,
      },
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
      },
    },
    // You can unslick at a given breakpoint now by adding:
    // settings: "unslick"
    // instead of a settings object
  ],
});
if ($(window).width() < 990) {
  // $(".product_stats").slick('unslick');
  $(".template--customers-account .account-header-main li:first-child").click(
    function () {
      $(".account-header-main li:not(:first-child)").slideToggle();
      $(".account-header-main ul").toggleClass("active-nav");
    }
  );
  $(".template-order-history .account-header-main li:last-child").click(
    function () {
      $(
        ".template-order-history .account-header-main li:not(:last-child)"
      ).slideToggle();
      $(".template-order-history .account-header-main ul").toggleClass(
        "active-nav"
      );
    }
  );
}

// $(".filter li").on('click', function(){
//   var filter = $(this).data('filter');
//   $(".filter li").removeClass("active");
//   $(this).addClass("active");
//   $(".slider-filter").slick('slickUnfilter');

//   if(filter == 'tab_1'){
//     $(".slider-filter").slick('slickFilter','.tab_1');
//   }
//   else if(filter == 'tab_2'){
//     $(".slider-filter").slick('slickFilter','.tab_2');
//   }
//   else if(filter == 'tab_3'){
//     $(".slider-filter").slick('slickFilter','.tab_3');
//   }

// })

// $(".filter li[data-filter='tab_1']").addClass("active");

// $(".filter li").on('click', function(){
//     var filter = $(this).data('filter');

//     $(".filter li").removeClass("active");
//     $(this).addClass("active");

//     $(".slider-filter").slick('slickUnfilter').slick('slickFilter', '.' + filter);
// });

$(document).ready(function () {
  // Initialize Slick Slider with custom arrows
  var $slider = $(".slider-filter").slick({
    dots: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    centerMode: false,
    prevArrow:
      '<button class="slide-arrow prev-arrow"><svg xmlns="http://www.w3.org/2000/svg" width="31" height="30" viewBox="0 0 31 30" fill="none"><path d="M15.1662 29L29.5551 15M29.5551 15L15.1662 1M29.5551 15H0.777344" stroke="#252525" stroke-width="1.3125" stroke-linecap="round" stroke-linejoin="round"/></svg></button>',
    nextArrow:
      '<button class="slide-arrow next-arrow"><svg xmlns="http://www.w3.org/2000/svg" width="31" height="30" viewBox="0 0 31 30" fill="none"><path d="M15.1662 29L29.5551 15M29.5551 15L15.1662 1M29.5551 15H0.777344" stroke="#252525" stroke-width="1.3125" stroke-linecap="round" stroke-linejoin="round"/></svg></button>',
  });

  // Tab click event
  $(".filter li").on("click", function () {
    var filter = $(this).data("filter");
    $(".filter li").removeClass("active");
    $(this).addClass("active");
    $slider.slick("slickUnfilter").slick("slickFilter", "." + filter);
  });

  // On slide change, update active tab
  $slider.on("afterChange", function (event, slick, currentSlide) {
    var currentClass = slick.$slides
      .eq(currentSlide)
      .attr("class")
      .split(" ")
      .find((c) => c.startsWith("tab_"));
    $(".filter li").removeClass("active");
    $(".filter li[data-filter='" + currentClass + "']").addClass("active");
  });
});

document.addEventListener("rebuy:cart.change", (event) => {
  // console.log('rebuy:cart.change event', event.detail);
  var add_amount = $("#label_goals .label__text--fill").text();
  var money_f = $("body").data("money-format");
  jQuery.getJSON("/cart.js", function (cart) {
    // now have access to Shopify cart object
    console.log("cart sub total" + cart.total_price);
    // var sub_total = theme.Currency.formatMoney(cart.total_price, theme.settings.moneyFormat);

    // sub__total = $(sub_total).text();
    //alert(sub__total);
    if (cart.total_price > 5900 && cart.total_price < 8900) {
      $("#goals").attr("value", 1);
      $("#goal-0").addClass("achieved-goal");
      $("#goal-1").removeClass("achieved-goal");
      var add_more = 8900 - cart.total_price;
      var add_item = formatMoney(add_more, money_f);
      $("#label_goals .label__text--fill").html("Add " + add_item + "!");
      $("#label_goals .label__text--unfill").text("To unlock free shipping");
      $("#label_goals .label__text--fill").removeClass(
        "label__text--fill-congrats"
      );
      $("#label_goals .label__text--unfill").removeClass("hide");
      $("#label_goals .arrow-goal-title").removeClass("hide");
      $(".rebuy-cart_goals-header h3").text("YOU'RE ALMOST THERE!");
    } else if (cart.total_price > 8900 && cart.total_price < 11000) {
      $("#goals").attr("value", 2);
      $("#goal-0").addClass("achieved-goal");
      $("#goal-1").addClass("achieved-goal");
      $("#goal-2").removeClass("achieved-goal");
      var add_more = 11000 - cart.total_price;
      var add_item = formatMoney(add_more, money_f);
      $("#label_goals .label__text--fill").html("Add " + add_item + "!");
      $("#label_goals .label__text--unfill").text("To unlock free Sliming tea");
      $("#label_goals .label__text--fill").removeClass(
        "label__text--fill-congrats"
      );
      $("#label_goals .label__text--unfill").removeClass("hide");
      $("#label_goals .arrow-goal-title").removeClass("hide");
      $(".rebuy-cart_goals-header h3").text("YOU'RE ALMOST THERE!");
    } else if (cart.total_price > 11000) {
      $("#goals").attr("value", 3);
      $("#goal-0").addClass("achieved-goal");
      $("#goal-1").addClass("achieved-goal");
      $("#goal-2").addClass("achieved-goal");
      $("#label_goals .label__text--fill").text("YOU'VE UNLOCKED ALL REWARDS");
      $("#label_goals .label__text--fill").addClass(
        "label__text--fill-congrats"
      );
      $("#label_goals .label__text--unfill").addClass("hide");
      $("#label_goals .arrow-goal-title").addClass("hide");
      $(".rebuy-cart_goals-header h3").text("CONGRATS!");
    } else {
      $("#goals").attr("value", 0);
      $("#goal-0").removeClass("achieved-goal");
      $("#goal-1").removeClass("achieved-goal");
      $("#goal-2").removeClass("achieved-goal");
      var add_more = 5900 - cart.total_price;

      var add_item = formatMoney(add_more, money_f);
      $("#label_goals .label__text--fill").html("Add " + add_item + "!");
      $("#label_goals .label__text--unfill").text(
        "To unlock Infinity Sweat Belt 2.0"
      );
      $("#label_goals .label__text--fill").removeClass(
        "label__text--fill-congrats"
      );
      $("#label_goals .label__text--unfill").removeClass("hide");
      $("#label_goals .arrow-goal-title").removeClass("hide");
      $(".rebuy-cart_goals-header h3").text("YOU'RE ALMOST THERE!");
    }

    //   for (var i = 0; i < cart.items.length; i++) {
    //   var currentItem = cart.items[i];
    //   var title = currentItem.title;
    // if(title.includes('Free Trial')){

    // }
    // }
  });
  $(".rebuy-cart__flyout-item").each(function () {
    var item_title = $(this)
      .find(".rebuy-cart__flyout-item-product-title")
      .text();
    console.log(item_title);
    if (item_title.includes("Super Fat Burner Free Trial")) {
      $(this)
        .find(".rebuy-cart__flyout-item-quantity")
        .find(".rebuy-cart__flyout-item-quantity-widget")
        .remove();
      var sale_price = $(this)
        .find(".rebuy-cart__flyout-item-price")
        .find(".sale")
        .find("span:last-child")
        .text();
      $(this)
        .find(".rebuy-cart__flyout-item-price")
        .find(".sale")
        .find("span:last-child")
        .text(sale_price.slice(0, 1) + "0.00");
    }
  });
});

document.addEventListener("rebuy:cart.ready", (event) => {
  $(".rebuy-cart__flyout-item").each(function () {
    var item_title = $(this)
      .find(".rebuy-cart__flyout-item-product-title")
      .text();
    console.log(item_title);
    if (item_title.includes("Super Fat Burner Free Trial")) {
      $(this)
        .find(".rebuy-cart__flyout-item-quantity")
        .find(".rebuy-cart__flyout-item-quantity-widget")
        .remove();
      var sale_price = $(this)
        .find(".rebuy-cart__flyout-item-price")
        .find(".sale")
        .find("span:last-child")
        .text();
      $(this)
        .find(".rebuy-cart__flyout-item-price")
        .find(".sale")
        .find("span:last-child")
        .text(sale_price.slice(0, 1) + "0.00");
    }
  });
});

document.querySelector(".header__icon--cart").addEventListener("click", () => {
  Rebuy.SmartCart.show();
});
